import type { PrescriptionsConfig } from '@grandvisionhq/fun-my-account'

export const getPrescriptionsConfig = (): PrescriptionsConfig => {
  return {
    daysOverdueThreshold: 730,
  }
}
